import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppIcon from './AppIcon'

export class AppButton extends Component {
  static propTypes = {
    buttonCls: PropTypes.string,
    buttonIconCls: PropTypes.string,
    clickHandler: PropTypes.func,
    disabled: PropTypes.bool,
    buttonLabel: PropTypes.string
  }

  static defaultProps = {
    buttonCls: '',
    buttonIconCls: '',
    disabled: false,
    buttonLabel: '',
    clickHandler: () => {}
  }

  render() {
    const { buttonCls, buttonIconCls, clickHandler, buttonLabel, disabled } = this.props;
    return (
      <button className={`app-button ${buttonCls} ${disabled ? 'btn-disabled' : ''}`} 
              onClick={disabled ? () => {} : clickHandler}>
          { buttonIconCls !== '' ? <AppIcon iconCls={buttonIconCls} /> : ''}
          { buttonLabel }
      </button>
    )
  }
}

export default AppButton
